import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import NavigationBar from '../../components/ui/NavigationBar';
import { BlogSection } from '../../components/ui/blog-section';
import { StickyFooter } from '../../components/ui/sticky-footer';

const BlogPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Blog | Nesolearn</title>
        <meta
          name="description"
          content="Insights, case studies, and thought leadership from the Nesolearn team on AI-powered learning, skills, and the future of work."
        />
        <meta property="og:title" content="Blog | Nesolearn" />
        <meta
          property="og:description"
          content="Insights, case studies, and thought leadership from the Nesolearn team."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/blog" />
      </Helmet>

      <div className="min-h-screen w-full overflow-x-hidden bg-white">
        <NavigationBar themed />

        <main className="pt-28">
          <div className="flex justify-center w-full px-4 md:px-8">
            <BlogSection />
          </div>
        </main>

        <StickyFooter />
      </div>
    </>
  );
};

export default BlogPage;